import React, { useState, Fragment, useContext, createContext } from 'react';
import { CloseButton, SimpleModal } from 'components';


export const ModalContext = createContext();


export const SecondaryModalProvider = ({ children }) => {
  const [activeModal, setActiveModal] = useState('');
  const [params, setParams] = useState({});
  const [modalInfo, setModalInfo] = useState({});

  return (
    <Fragment>
      <ModalContext.Provider
        value={{
          activeModal,
          setActiveModal,
          params,
          setParams,
          setModalInfo,
          modalInfo,
        }}>

        {children}
      </ModalContext.Provider>
    </Fragment>
  );
};

export const useSecondaryModal = (info) => {
  const { setActiveModal, params, setParams, setModalInfo, modalInfo } = useContext(ModalContext);

  return {
    openSecondary: (params = {}) => {
      setActiveModal(true);
      setParams(params);
      setModalInfo(info)
    },
    closeSecondary: () => {
      setActiveModal('');
      setParams({});
      setModalInfo({});
    },
    params,
    modalInfo
  };
};


export const AllSecondaryModals = () => {
  const { activeModal } = useContext(ModalContext);
  const { closeSecondary, params, modalInfo } = useSecondaryModal();


  return (
    <SimpleModal
      handleOpenClose={closeSecondary}
      openDefault={activeModal ? activeModal : false}
      content={
        <div style={{ outline: 'none' }} className="modal-wrapper-style">
          {!modalInfo?.noCloseButton &&
            <div className="modal-header-style">
              <CloseButton handleCLic={closeSecondary} />
            </div>
          }
          <div className={modalInfo?.noPadding ? 'modal-body-style-no-padding' : "modal-body-style"}>
            {params}
          </div>
        </div>
      }
    />
  );
};